/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from '../../../com/atproto/server/defs.defs'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs'
import * as ModerationDefs from '../../../com/atproto/moderation/defs.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'
import * as ConvoDefs from '../../../chat/bsky/convo/defs.defs'
import * as LabelDefs from '../../../com/atproto/label/defs.defs'
import * as AgeassuranceDefs from '../../../app/bsky/ageassurance/defs.defs'

const $nsid = 'tools.ozone.moderation.defs'

type $nsid = typeof $nsid

export { $nsid }

/** Moderation tool information for tracing the source of the action */
type ModTool = {
  $type?: 'tools.ozone.moderation.defs#modTool'

  /**
   * Additional arbitrary metadata about the source
   */
  meta?: l.LexMap

  /**
   * Name/identifier of the source (e.g., 'automod', 'ozone/workspace')
   */
  name: string
}

export type { ModTool }

/** Moderation tool information for tracing the source of the action */
const modTool = /*#__PURE__*/ l.typedObject<ModTool>(
  $nsid,
  'modTool',
  /*#__PURE__*/ l.object({
    meta: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    name: /*#__PURE__*/ l.string(),
  }),
)

export { modTool }

type BlobView = {
  $type?: 'tools.ozone.moderation.defs#blobView'
  cid: l.CidString
  size: number
  details?:
    l.$Typed<ImageDetails> | l.$Typed<VideoDetails> | l.Unknown$TypedObject
  mimeType: string
  createdAt: l.DatetimeString
  moderation?: Moderation
}

export type { BlobView }

const blobView = /*#__PURE__*/ l.typedObject<BlobView>(
  $nsid,
  'blobView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    size: /*#__PURE__*/ l.integer(),
    details: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ImageDetails>((() => imageDetails) as any),
          /*#__PURE__*/ l.typedRef<VideoDetails>((() => videoDetails) as any),
        ],
        false,
      ),
    ),
    mimeType: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
    ),
  }),
)

export { blobView }

type RepoView = {
  $type?: 'tools.ozone.moderation.defs#repoView'
  did: l.DidString
  email?: string
  handle: l.HandleString
  indexedAt: l.DatetimeString
  invitedBy?: ServerDefs.InviteCode
  inviteNote?: string
  moderation: Moderation
  deactivatedAt?: l.DatetimeString
  relatedRecords: l.LexMap[]
  invitesDisabled?: boolean
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoView }

const repoView = /*#__PURE__*/ l.typedObject<RepoView>(
  $nsid,
  'repoView',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    moderation: /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    relatedRecords: /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoView }

type ConvoView = {
  $type?: 'tools.ozone.moderation.defs#convoView'
  did: l.DidString
  convoId: string
}

export type { ConvoView }

const convoView = /*#__PURE__*/ l.typedObject<ConvoView>(
  $nsid,
  'convoView',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { convoView }

type Moderation = {
  $type?: 'tools.ozone.moderation.defs#moderation'
  subjectStatus?: SubjectStatusView
}

export type { Moderation }

const moderation = /*#__PURE__*/ l.typedObject<Moderation>(
  $nsid,
  'moderation',
  /*#__PURE__*/ l.object({
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderation }

type RecordView = {
  $type?: 'tools.ozone.moderation.defs#recordView'
  cid: l.CidString
  uri: l.AtUriString
  repo: RepoView
  value: l.LexMap
  blobCids: l.CidString[]
  indexedAt: l.DatetimeString
  moderation: Moderation
}

export type { RecordView }

const recordView = /*#__PURE__*/ l.typedObject<RecordView>(
  $nsid,
  'recordView',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    repo: /*#__PURE__*/ l.ref<RepoView>((() => repoView) as any),
    value: /*#__PURE__*/ l.lexMap(),
    blobCids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'cid' })),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<Moderation>((() => moderation) as any),
  }),
)

export { recordView }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
const reviewNone = /*#__PURE__*/ l.token($nsid, 'reviewNone')

export { reviewNone }

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
const ReviewNone = /*#__PURE__*/ reviewNone.value

/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */
type ReviewNone = typeof ReviewNone

export { ReviewNone }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
const reviewOpen = /*#__PURE__*/ l.token($nsid, 'reviewOpen')

export { reviewOpen }

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
const ReviewOpen = /*#__PURE__*/ reviewOpen.value

/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */
type ReviewOpen = typeof ReviewOpen

export { ReviewOpen }

/** Add/Remove a tag on a subject */
type ModEventTag = {
  $type?: 'tools.ozone.moderation.defs#modEventTag'

  /**
   * Tags to be added to the subject. If already exists, won't be duplicated.
   */
  add: string[]

  /**
   * Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated.
   */
  remove: string[]

  /**
   * Additional comment about added/removed tags.
   */
  comment?: string

  /**
   * Indicates how long the tags being added should remain before automatically being removed. Only applies to tags being added.
   */
  durationInHours?: number
}

export type { ModEventTag }

/** Add/Remove a tag on a subject */
const modEventTag = /*#__PURE__*/ l.typedObject<ModEventTag>(
  $nsid,
  'modEventTag',
  /*#__PURE__*/ l.object({
    add: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    remove: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { modEventTag }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type RecordEvent = {
  $type?: 'tools.ozone.moderation.defs#recordEvent'
  op: 'create' | 'update' | 'delete' | l.UnknownString
  cid?: l.CidString
  comment?: string
  timestamp: l.DatetimeString
}

export type { RecordEvent }

/** Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const recordEvent = /*#__PURE__*/ l.typedObject<RecordEvent>(
  $nsid,
  'recordEvent',
  /*#__PURE__*/ l.object({
    op: /*#__PURE__*/ l.string<{
      knownValues: ['create', 'update', 'delete']
    }>(),
    cid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'cid' })),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { recordEvent }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
type SubjectView = {
  $type?: 'tools.ozone.moderation.defs#subjectView'
  repo?: RepoViewDetail
  type: ModerationDefs.SubjectType
  record?: RecordViewDetail
  status?: SubjectStatusView
  profile?: l.Unknown$TypedObject
  subject: string
}

export type { SubjectView }

/** Detailed view of a subject. For record subjects, the author's repo and profile will be returned. */
const subjectView = /*#__PURE__*/ l.typedObject<SubjectView>(
  $nsid,
  'subjectView',
  /*#__PURE__*/ l.object({
    repo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoViewDetail>((() => repoViewDetail) as any),
    ),
    type: /*#__PURE__*/ l.ref<ModerationDefs.SubjectType>(
      (() => ModerationDefs.subjectType) as any,
    ),
    record: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RecordViewDetail>((() => recordViewDetail) as any),
    ),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
    profile: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([], false)),
    subject: /*#__PURE__*/ l.string(),
  }),
)

export { subjectView }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type AccountEvent = {
  $type?: 'tools.ozone.moderation.defs#accountEvent'

  /**
   * Indicates that the account has a repository which can be fetched from the host that emitted this event.
   */
  active: boolean
  status?:
    | 'unknown'
    | 'deactivated'
    | 'deleted'
    | 'takendown'
    | 'suspended'
    | 'tombstoned'
    | l.UnknownString
  comment?: string
  timestamp: l.DatetimeString
}

export type { AccountEvent }

/** Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const accountEvent = /*#__PURE__*/ l.typedObject<AccountEvent>(
  $nsid,
  'accountEvent',
  /*#__PURE__*/ l.object({
    active: /*#__PURE__*/ l.boolean(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'unknown',
          'deactivated',
          'deleted',
          'takendown',
          'suspended',
          'tombstoned',
        ]
      }>(),
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { accountEvent }

/** Statistics about a particular account subject */
type AccountStats = {
  $type?: 'tools.ozone.moderation.defs#accountStats'

  /**
   * Total number of appeals against a moderation action on the account
   */
  appealCount?: number

  /**
   * Total number of reports on the account
   */
  reportCount?: number

  /**
   * Number of times the account was suspended
   */
  suspendCount?: number

  /**
   * Number of times the account was escalated
   */
  escalateCount?: number

  /**
   * Number of times the account was taken down
   */
  takedownCount?: number
}

export type { AccountStats }

/** Statistics about a particular account subject */
const accountStats = /*#__PURE__*/ l.typedObject<AccountStats>(
  $nsid,
  'accountStats',
  /*#__PURE__*/ l.object({
    appealCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    reportCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    suspendCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalateCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    takedownCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { accountStats }

type ImageDetails = {
  $type?: 'tools.ozone.moderation.defs#imageDetails'
  width: number
  height: number
}

export type { ImageDetails }

const imageDetails = /*#__PURE__*/ l.typedObject<ImageDetails>(
  $nsid,
  'imageDetails',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer(),
    height: /*#__PURE__*/ l.integer(),
  }),
)

export { imageDetails }

/** Mute incoming reports on a subject */
type ModEventMute = {
  $type?: 'tools.ozone.moderation.defs#modEventMute'
  comment?: string

  /**
   * Indicates how long the subject should remain muted.
   */
  durationInHours: number
}

export type { ModEventMute }

/** Mute incoming reports on a subject */
const modEventMute = /*#__PURE__*/ l.typedObject<ModEventMute>(
  $nsid,
  'modEventMute',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.integer(),
  }),
)

export { modEventMute }

type ModEventView = {
  $type?: 'tools.ozone.moderation.defs#modEventView'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  modTool?: ModTool
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.$Typed<ConvoDefs.ConvoRef>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  createdBy: l.DidString
  creatorHandle?: string
  subjectHandle?: string
  subjectBlobCids: string[]
}

export type { ModEventView }

const modEventView = /*#__PURE__*/ l.typedObject<ModEventView>(
  $nsid,
  'modEventView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    event: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ModEventTakedown>(
          (() => modEventTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventComment>(
          (() => modEventComment) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReport>((() => modEventReport) as any),
        /*#__PURE__*/ l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        /*#__PURE__*/ l.typedRef<ModEventAcknowledge>(
          (() => modEventAcknowledge) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEscalate>(
          (() => modEventEscalate) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventMute>((() => modEventMute) as any),
        /*#__PURE__*/ l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        /*#__PURE__*/ l.typedRef<ModEventMuteReporter>(
          (() => modEventMuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        /*#__PURE__*/ l.typedRef<ModEventResolveAppeal>(
          (() => modEventResolveAppeal) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        /*#__PURE__*/ l.typedRef<ModEventTag>((() => modEventTag) as any),
        /*#__PURE__*/ l.typedRef<AccountEvent>((() => accountEvent) as any),
        /*#__PURE__*/ l.typedRef<IdentityEvent>((() => identityEvent) as any),
        /*#__PURE__*/ l.typedRef<RecordEvent>((() => recordEvent) as any),
        /*#__PURE__*/ l.typedRef<ModEventPriorityScore>(
          (() => modEventPriorityScore) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceEvent>(
          (() => ageAssuranceEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<ScheduleTakedownEvent>(
          (() => scheduleTakedownEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    modTool: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModTool>((() => modTool) as any),
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.ConvoRef>(
          (() => ConvoDefs.convoRef) as any,
        ),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    creatorHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    subjectHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    subjectBlobCids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  }),
)

export { modEventView }

/** Statistics about a set of record subject items */
type RecordsStats = {
  $type?: 'tools.ozone.moderation.defs#recordsStats'

  /**
   * Number of item currently in "reviewOpen" or "reviewEscalated" state
   */
  pendingCount?: number

  /**
   * Total number of item in the set
   */
  subjectCount?: number

  /**
   * Cumulative sum of the number of reports on the items in the set
   */
  totalReports?: number

  /**
   * Number of items that were appealed at least once
   */
  appealedCount?: number

  /**
   * Number of items that were reported at least once
   */
  reportedCount?: number

  /**
   * Number of items that were escalated at least once
   */
  escalatedCount?: number

  /**
   * Number of item currently in "reviewNone" or "reviewClosed" state
   */
  processedCount?: number

  /**
   * Number of item currently taken down
   */
  takendownCount?: number
}

export type { RecordsStats }

/** Statistics about a set of record subject items */
const recordsStats = /*#__PURE__*/ l.typedObject<RecordsStats>(
  $nsid,
  'recordsStats',
  /*#__PURE__*/ l.object({
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    subjectCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    totalReports: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    appealedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    reportedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    processedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    takendownCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { recordsStats }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
const reviewClosed = /*#__PURE__*/ l.token($nsid, 'reviewClosed')

export { reviewClosed }

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
const ReviewClosed = /*#__PURE__*/ reviewClosed.value

/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */
type ReviewClosed = typeof ReviewClosed

export { ReviewClosed }

type VideoDetails = {
  $type?: 'tools.ozone.moderation.defs#videoDetails'
  width: number
  height: number
  length: number
}

export type { VideoDetails }

const videoDetails = /*#__PURE__*/ l.typedObject<VideoDetails>(
  $nsid,
  'videoDetails',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer(),
    height: /*#__PURE__*/ l.integer(),
    length: /*#__PURE__*/ l.integer(),
  }),
)

export { videoDetails }

/** Strike information for an account */
type AccountStrike = {
  $type?: 'tools.ozone.moderation.defs#accountStrike'

  /**
   * Timestamp of the most recent strike received
   */
  lastStrikeAt?: l.DatetimeString

  /**
   * Timestamp of the first strike received
   */
  firstStrikeAt?: l.DatetimeString

  /**
   * Total number of strikes ever received (including expired strikes)
   */
  totalStrikeCount?: number

  /**
   * Current number of active strikes (excluding expired strikes)
   */
  activeStrikeCount?: number
}

export type { AccountStrike }

/** Strike information for an account */
const accountStrike = /*#__PURE__*/ l.typedObject<AccountStrike>(
  $nsid,
  'accountStrike',
  /*#__PURE__*/ l.object({
    lastStrikeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    firstStrikeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    totalStrikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    activeStrikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { accountStrike }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
type IdentityEvent = {
  $type?: 'tools.ozone.moderation.defs#identityEvent'
  handle?: l.HandleString
  comment?: string
  pdsHost?: l.UriString
  timestamp: l.DatetimeString
  tombstone?: boolean
}

export type { IdentityEvent }

/** Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking. */
const identityEvent = /*#__PURE__*/ l.typedObject<IdentityEvent>(
  $nsid,
  'identityEvent',
  /*#__PURE__*/ l.object({
    handle: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'handle' }),
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    pdsHost: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
    timestamp: /*#__PURE__*/ l.string({ format: 'datetime' }),
    tombstone: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { identityEvent }

/** Keep a log of outgoing email to a user */
type ModEventEmail = {
  $type?: 'tools.ozone.moderation.defs#modEventEmail'

  /**
   * Additional comment about the outgoing comm.
   */
  comment?: string

  /**
   * The content of the email sent to the user.
   */
  content?: string

  /**
   * Names/Keywords of the policies that necessitated the email.
   */
  policies?: string[]

  /**
   * Indicates whether the email was successfully delivered to the user's inbox.
   */
  isDelivered?: boolean

  /**
   * Number of strikes to assign to the user for this violation. Normally 0 as an indicator of a warning and only added as a strike on a repeat offense.
   */
  strikeCount?: number

  /**
   * The subject line of the email sent to the user.
   */
  subjectLine: string

  /**
   * Severity level of the violation. Normally 'sev-1' that adds strike on repeat offense
   */
  severityLevel?: string

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString
}

export type { ModEventEmail }

/** Keep a log of outgoing email to a user */
const modEventEmail = /*#__PURE__*/ l.typedObject<ModEventEmail>(
  $nsid,
  'modEventEmail',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    content: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
    ),
    isDelivered: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    subjectLine: /*#__PURE__*/ l.string(),
    severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    strikeExpiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { modEventEmail }

/** Apply/Negate labels on a subject */
type ModEventLabel = {
  $type?: 'tools.ozone.moderation.defs#modEventLabel'
  comment?: string
  createLabelVals: string[]

  /**
   * Indicates how long the label will remain on the subject. Only applies on labels that are being added.
   */
  durationInHours?: number
  negateLabelVals: string[]
}

export type { ModEventLabel }

/** Apply/Negate labels on a subject */
const modEventLabel = /*#__PURE__*/ l.typedObject<ModEventLabel>(
  $nsid,
  'modEventLabel',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    createLabelVals: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    negateLabelVals: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  }),
)

export { modEventLabel }

type RecordHosting = {
  $type?: 'tools.ozone.moderation.defs#recordHosting'
  status: 'deleted' | 'unknown' | l.UnknownString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
}

export type { RecordHosting }

const recordHosting = /*#__PURE__*/ l.typedObject<RecordHosting>(
  $nsid,
  'recordHosting',
  /*#__PURE__*/ l.object({
    status: /*#__PURE__*/ l.string<{ knownValues: ['deleted', 'unknown'] }>(),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { recordHosting }

type ReporterStats = {
  $type?: 'tools.ozone.moderation.defs#reporterStats'
  did: l.DidString

  /**
   * The total number of reports made by the user on records.
   */
  recordReportCount: number

  /**
   * The total number of reports made by the user on accounts.
   */
  accountReportCount: number

  /**
   * The total number of records labeled as a result of the user's reports.
   */
  labeledRecordCount: number

  /**
   * The total number of accounts labeled as a result of the user's reports.
   */
  labeledAccountCount: number

  /**
   * The total number of records reported by the user.
   */
  reportedRecordCount: number

  /**
   * The total number of accounts reported by the user.
   */
  reportedAccountCount: number

  /**
   * The total number of records taken down as a result of the user's reports.
   */
  takendownRecordCount: number

  /**
   * The total number of accounts taken down as a result of the user's reports.
   */
  takendownAccountCount: number
}

export type { ReporterStats }

const reporterStats = /*#__PURE__*/ l.typedObject<ReporterStats>(
  $nsid,
  'reporterStats',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    recordReportCount: /*#__PURE__*/ l.integer(),
    accountReportCount: /*#__PURE__*/ l.integer(),
    labeledRecordCount: /*#__PURE__*/ l.integer(),
    labeledAccountCount: /*#__PURE__*/ l.integer(),
    reportedRecordCount: /*#__PURE__*/ l.integer(),
    reportedAccountCount: /*#__PURE__*/ l.integer(),
    takendownRecordCount: /*#__PURE__*/ l.integer(),
    takendownAccountCount: /*#__PURE__*/ l.integer(),
  }),
)

export { reporterStats }

type AccountHosting = {
  $type?: 'tools.ozone.moderation.defs#accountHosting'
  status:
    | 'takendown'
    | 'suspended'
    | 'deleted'
    | 'deactivated'
    | 'unknown'
    | l.UnknownString
  createdAt?: l.DatetimeString
  deletedAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  deactivatedAt?: l.DatetimeString
  reactivatedAt?: l.DatetimeString
}

export type { AccountHosting }

const accountHosting = /*#__PURE__*/ l.typedObject<AccountHosting>(
  $nsid,
  'accountHosting',
  /*#__PURE__*/ l.object({
    status: /*#__PURE__*/ l.string<{
      knownValues: [
        'takendown',
        'suspended',
        'deleted',
        'deactivated',
        'unknown',
      ]
    }>(),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    reactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { accountHosting }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
type ModEventDivert = {
  $type?: 'tools.ozone.moderation.defs#modEventDivert'
  comment?: string
}

export type { ModEventDivert }

/** Divert a record's blobs to a 3rd party service for further scanning/tagging */
const modEventDivert = /*#__PURE__*/ l.typedObject<ModEventDivert>(
  $nsid,
  'modEventDivert',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventDivert }

/** Report a subject */
type ModEventReport = {
  $type?: 'tools.ozone.moderation.defs#modEventReport'
  comment?: string
  reportType: ModerationDefs.ReasonType
  appealLabel?: string
  appealActionId?: number

  /**
   * Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject.
   */
  isReporterMuted?: boolean

  /**
   * Action reference type recorded when this appeal was submitted.
   */
  appealActionType?: string

  /**
   * Moderator who submitted this appeal on behalf of the affected account. Returned by moderator event APIs.
   */
  appealSubmittedBy?: l.DidString
}

export type { ModEventReport }

/** Report a subject */
const modEventReport = /*#__PURE__*/ l.typedObject<ModEventReport>(
  $nsid,
  'modEventReport',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    reportType: /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
      (() => ModerationDefs.reasonType) as any,
    ),
    appealLabel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    appealActionId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    isReporterMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    appealActionType: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    appealSubmittedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
  }),
)

export { modEventReport }

/** Unmute action on a subject */
type ModEventUnmute = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmute'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmute }

/** Unmute action on a subject */
const modEventUnmute = /*#__PURE__*/ l.typedObject<ModEventUnmute>(
  $nsid,
  'modEventUnmute',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventUnmute }

type RepoViewDetail = {
  $type?: 'tools.ozone.moderation.defs#repoViewDetail'
  did: l.DidString
  email?: string
  handle: l.HandleString
  labels?: LabelDefs.Label[]
  invites?: ServerDefs.InviteCode[]
  indexedAt: l.DatetimeString
  invitedBy?: ServerDefs.InviteCode
  inviteNote?: string
  moderation: ModerationDetail
  deactivatedAt?: l.DatetimeString
  relatedRecords: l.LexMap[]
  invitesDisabled?: boolean
  emailConfirmedAt?: l.DatetimeString
  threatSignatures?: AdminDefs.ThreatSignature[]
}

export type { RepoViewDetail }

const repoViewDetail = /*#__PURE__*/ l.typedObject<RepoViewDetail>(
  $nsid,
  'repoViewDetail',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    invites: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
          (() => ServerDefs.inviteCode) as any,
        ),
      ),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    moderation: /*#__PURE__*/ l.ref<ModerationDetail>(
      (() => moderationDetail) as any,
    ),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    relatedRecords: /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    emailConfirmedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<AdminDefs.ThreatSignature>(
          (() => AdminDefs.threatSignature) as any,
        ),
      ),
    ),
  }),
)

export { repoViewDetail }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
type ModEventComment = {
  $type?: 'tools.ozone.moderation.defs#modEventComment'

  /**
   * Make the comment persistent on the subject
   */
  sticky?: boolean
  comment?: string
}

export type { ModEventComment }

/** Add a comment to a subject. An empty comment will clear any previously set sticky comment. */
const modEventComment = /*#__PURE__*/ l.typedObject<ModEventComment>(
  $nsid,
  'modEventComment',
  /*#__PURE__*/ l.object({
    sticky: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventComment }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
const reviewEscalated = /*#__PURE__*/ l.token($nsid, 'reviewEscalated')

export { reviewEscalated }

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
const ReviewEscalated = /*#__PURE__*/ reviewEscalated.value

/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */
type ReviewEscalated = typeof ReviewEscalated

export { ReviewEscalated }

type ModEventEscalate = {
  $type?: 'tools.ozone.moderation.defs#modEventEscalate'
  comment?: string
}

export type { ModEventEscalate }

const modEventEscalate = /*#__PURE__*/ l.typedObject<ModEventEscalate>(
  $nsid,
  'modEventEscalate',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { modEventEscalate }

/** Take down a subject permanently or temporarily */
type ModEventTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventTakedown'
  comment?: string

  /**
   * Names/Keywords of the policies that drove the decision.
   */
  policies?: string[]

  /**
   * Number of strikes to assign to the user for this violation.
   */
  strikeCount?: number

  /**
   * Severity level of the violation (e.g., 'sev-0', 'sev-1', 'sev-2', etc.).
   */
  severityLevel?: string

  /**
   * List of services where the takedown should be applied. If empty or not provided, takedown is applied on all configured services.
   */
  targetServices?: ('appview' | 'pds' | l.UnknownString)[]

  /**
   * Indicates how long the takedown should be in effect before automatically expiring.
   */
  durationInHours?: number

  /**
   * When the strike should expire. If not provided, the strike never expires.
   */
  strikeExpiresAt?: l.DatetimeString

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean
}

export type { ModEventTakedown }

/** Take down a subject permanently or temporarily */
const modEventTakedown = /*#__PURE__*/ l.typedObject<ModEventTakedown>(
  $nsid,
  'modEventTakedown',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    policies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
    ),
    strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    targetServices: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{ knownValues: ['appview', 'pds'] }>(),
      ),
    ),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    strikeExpiresAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    acknowledgeAccountSubjects: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.boolean(),
    ),
  }),
)

export { modEventTakedown }

type ModerationDetail = {
  $type?: 'tools.ozone.moderation.defs#moderationDetail'
  subjectStatus?: SubjectStatusView
}

export type { ModerationDetail }

const moderationDetail = /*#__PURE__*/ l.typedObject<ModerationDetail>(
  $nsid,
  'moderationDetail',
  /*#__PURE__*/ l.object({
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<SubjectStatusView>((() => subjectStatusView) as any),
    ),
  }),
)

export { moderationDetail }

type RecordViewDetail = {
  $type?: 'tools.ozone.moderation.defs#recordViewDetail'
  cid: l.CidString
  uri: l.AtUriString
  repo: RepoView
  blobs: BlobView[]
  value: l.LexMap
  labels?: LabelDefs.Label[]
  indexedAt: l.DatetimeString
  moderation: ModerationDetail
}

export type { RecordViewDetail }

const recordViewDetail = /*#__PURE__*/ l.typedObject<RecordViewDetail>(
  $nsid,
  'recordViewDetail',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    repo: /*#__PURE__*/ l.ref<RepoView>((() => repoView) as any),
    blobs: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<BlobView>((() => blobView) as any),
    ),
    value: /*#__PURE__*/ l.lexMap(),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderation: /*#__PURE__*/ l.ref<ModerationDetail>(
      (() => moderationDetail) as any,
    ),
  }),
)

export { recordViewDetail }

type RepoViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#repoViewNotFound'
  did: l.DidString
}

export type { RepoViewNotFound }

const repoViewNotFound = /*#__PURE__*/ l.typedObject<RepoViewNotFound>(
  $nsid,
  'repoViewNotFound',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repoViewNotFound }

/** Age assurance info coming directly from users. Only works on DID subjects. */
type AgeAssuranceEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceEvent'
  access?: AgeassuranceDefs.Access

  /**
   * The IP address used when initiating the AA flow.
   */
  initIp?: string

  /**
   * The user agent used when initiating the AA flow.
   */
  initUa?: string

  /**
   * The status of the Age Assurance process.
   */
  status: 'unknown' | 'pending' | 'assured' | l.UnknownString

  /**
   * The unique identifier for this instance of the age assurance flow, in UUID format.
   */
  attemptId: string

  /**
   * The date and time of this write operation.
   */
  createdAt: l.DatetimeString

  /**
   * The IP address used when completing the AA flow.
   */
  completeIp?: string

  /**
   * The user agent used when completing the AA flow.
   */
  completeUa?: string

  /**
   * The ISO 3166-2 region code provided when beginning the Age Assurance flow.
   */
  regionCode?: string

  /**
   * The ISO 3166-1 alpha-2 country code provided when beginning the Age Assurance flow.
   */
  countryCode?: string
}

export type { AgeAssuranceEvent }

/** Age assurance info coming directly from users. Only works on DID subjects. */
const ageAssuranceEvent = /*#__PURE__*/ l.typedObject<AgeAssuranceEvent>(
  $nsid,
  'ageAssuranceEvent',
  /*#__PURE__*/ l.object({
    access: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AgeassuranceDefs.Access>(
        (() => AgeassuranceDefs.access) as any,
      ),
    ),
    initIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    initUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['unknown', 'pending', 'assured']
    }>(),
    attemptId: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    completeIp: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    completeUa: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    regionCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    countryCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { ageAssuranceEvent }

type SubjectStatusView = {
  $type?: 'tools.ozone.moderation.defs#subjectStatusView'
  id: number
  tags?: string[]

  /**
   * Sticky comment on the subject.
   */
  comment?: string
  hosting?:
    l.$Typed<AccountHosting> | l.$Typed<RecordHosting> | l.Unknown$TypedObject
  subject:
    | l.$Typed<AdminDefs.RepoRef>
    | l.$Typed<RepoStrongRef.Main>
    | l.$Typed<ConvoDefs.MessageRef>
    | l.$Typed<ConvoDefs.ConvoRef>
    | l.Unknown$TypedObject

  /**
   * True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators.
   */
  appealed?: boolean

  /**
   * Timestamp referencing the first moderation status impacting event was emitted on the subject
   */
  createdAt: l.DatetimeString
  muteUntil?: l.DatetimeString
  takendown?: boolean

  /**
   * Timestamp referencing when the last update was made to the moderation status of the subject
   */
  updatedAt: l.DatetimeString
  reviewState: SubjectReviewState

  /**
   * Statistics related to the account subject
   */
  accountStats?: AccountStats

  /**
   * Statistics related to the record subjects authored by the subject's account
   */
  recordsStats?: RecordsStats
  suspendUntil?: l.DatetimeString

  /**
   * Strike information for the account (account-level only)
   */
  accountStrike?: AccountStrike

  /**
   * Numeric value representing the level of priority. Higher score means higher priority.
   */
  priorityScore?: number

  /**
   * Timestamp referencing when the author of the subject appealed a moderation action
   */
  lastAppealedAt?: l.DatetimeString
  lastReportedAt?: l.DatetimeString
  lastReviewedAt?: l.DatetimeString
  lastReviewedBy?: l.DidString
  subjectBlobCids?: l.CidString[]

  /**
   * Current age assurance state of the subject.
   */
  ageAssuranceState?:
    'pending' | 'assured' | 'unknown' | 'reset' | 'blocked' | l.UnknownString
  subjectRepoHandle?: string
  muteReportingUntil?: l.DatetimeString

  /**
   * Whether or not the last successful update to age assurance was made by the user or admin.
   */
  ageAssuranceUpdatedBy?: 'admin' | 'user' | l.UnknownString
}

export type { SubjectStatusView }

const subjectStatusView = /*#__PURE__*/ l.typedObject<SubjectStatusView>(
  $nsid,
  'subjectStatusView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    tags: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    hosting: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<AccountHosting>(
            (() => accountHosting) as any,
          ),
          /*#__PURE__*/ l.typedRef<RecordHosting>((() => recordHosting) as any),
        ],
        false,
      ),
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
          (() => AdminDefs.repoRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
          (() => RepoStrongRef.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.MessageRef>(
          (() => ConvoDefs.messageRef) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoDefs.ConvoRef>(
          (() => ConvoDefs.convoRef) as any,
        ),
      ],
      false,
    ),
    appealed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    muteUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    takendown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    reviewState: /*#__PURE__*/ l.ref<SubjectReviewState>(
      (() => subjectReviewState) as any,
    ),
    accountStats: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AccountStats>((() => accountStats) as any),
    ),
    recordsStats: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RecordsStats>((() => recordsStats) as any),
    ),
    suspendUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    accountStrike: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<AccountStrike>((() => accountStrike) as any),
    ),
    priorityScore: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 0 }),
    ),
    lastAppealedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastReportedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastReviewedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastReviewedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    subjectBlobCids: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'cid' })),
    ),
    ageAssuranceState: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
      }>(),
    ),
    subjectRepoHandle: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    muteReportingUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    ageAssuranceUpdatedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['admin', 'user'] }>(),
    ),
  }),
)

export { subjectStatusView }

type ModEventViewDetail = {
  $type?: 'tools.ozone.moderation.defs#modEventViewDetail'
  id: number
  event:
    | l.$Typed<ModEventTakedown>
    | l.$Typed<ModEventReverseTakedown>
    | l.$Typed<ModEventComment>
    | l.$Typed<ModEventReport>
    | l.$Typed<ModEventLabel>
    | l.$Typed<ModEventAcknowledge>
    | l.$Typed<ModEventEscalate>
    | l.$Typed<ModEventMute>
    | l.$Typed<ModEventUnmute>
    | l.$Typed<ModEventMuteReporter>
    | l.$Typed<ModEventUnmuteReporter>
    | l.$Typed<ModEventEmail>
    | l.$Typed<ModEventResolveAppeal>
    | l.$Typed<ModEventDivert>
    | l.$Typed<ModEventTag>
    | l.$Typed<AccountEvent>
    | l.$Typed<IdentityEvent>
    | l.$Typed<RecordEvent>
    | l.$Typed<ModEventPriorityScore>
    | l.$Typed<AgeAssuranceEvent>
    | l.$Typed<AgeAssuranceOverrideEvent>
    | l.$Typed<AgeAssurancePurgeEvent>
    | l.$Typed<RevokeAccountCredentialsEvent>
    | l.$Typed<ScheduleTakedownEvent>
    | l.$Typed<CancelScheduledTakedownEvent>
    | l.Unknown$TypedObject
  modTool?: ModTool
  subject:
    | l.$Typed<RepoView>
    | l.$Typed<RepoViewNotFound>
    | l.$Typed<RecordView>
    | l.$Typed<RecordViewNotFound>
    | l.$Typed<ConvoView>
    | l.Unknown$TypedObject
  createdAt: l.DatetimeString
  createdBy: l.DidString
  subjectBlobs: BlobView[]
}

export type { ModEventViewDetail }

const modEventViewDetail = /*#__PURE__*/ l.typedObject<ModEventViewDetail>(
  $nsid,
  'modEventViewDetail',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    event: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ModEventTakedown>(
          (() => modEventTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReverseTakedown>(
          (() => modEventReverseTakedown) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventComment>(
          (() => modEventComment) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventReport>((() => modEventReport) as any),
        /*#__PURE__*/ l.typedRef<ModEventLabel>((() => modEventLabel) as any),
        /*#__PURE__*/ l.typedRef<ModEventAcknowledge>(
          (() => modEventAcknowledge) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEscalate>(
          (() => modEventEscalate) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventMute>((() => modEventMute) as any),
        /*#__PURE__*/ l.typedRef<ModEventUnmute>((() => modEventUnmute) as any),
        /*#__PURE__*/ l.typedRef<ModEventMuteReporter>(
          (() => modEventMuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventUnmuteReporter>(
          (() => modEventUnmuteReporter) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventEmail>((() => modEventEmail) as any),
        /*#__PURE__*/ l.typedRef<ModEventResolveAppeal>(
          (() => modEventResolveAppeal) as any,
        ),
        /*#__PURE__*/ l.typedRef<ModEventDivert>((() => modEventDivert) as any),
        /*#__PURE__*/ l.typedRef<ModEventTag>((() => modEventTag) as any),
        /*#__PURE__*/ l.typedRef<AccountEvent>((() => accountEvent) as any),
        /*#__PURE__*/ l.typedRef<IdentityEvent>((() => identityEvent) as any),
        /*#__PURE__*/ l.typedRef<RecordEvent>((() => recordEvent) as any),
        /*#__PURE__*/ l.typedRef<ModEventPriorityScore>(
          (() => modEventPriorityScore) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceEvent>(
          (() => ageAssuranceEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssuranceOverrideEvent>(
          (() => ageAssuranceOverrideEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<AgeAssurancePurgeEvent>(
          (() => ageAssurancePurgeEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<RevokeAccountCredentialsEvent>(
          (() => revokeAccountCredentialsEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<ScheduleTakedownEvent>(
          (() => scheduleTakedownEvent) as any,
        ),
        /*#__PURE__*/ l.typedRef<CancelScheduledTakedownEvent>(
          (() => cancelScheduledTakedownEvent) as any,
        ),
      ],
      false,
    ),
    modTool: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModTool>((() => modTool) as any),
    ),
    subject: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<RepoView>((() => repoView) as any),
        /*#__PURE__*/ l.typedRef<RepoViewNotFound>(
          (() => repoViewNotFound) as any,
        ),
        /*#__PURE__*/ l.typedRef<RecordView>((() => recordView) as any),
        /*#__PURE__*/ l.typedRef<RecordViewNotFound>(
          (() => recordViewNotFound) as any,
        ),
        /*#__PURE__*/ l.typedRef<ConvoView>((() => convoView) as any),
      ],
      false,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    subjectBlobs: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<BlobView>((() => blobView) as any),
    ),
  }),
)

export { modEventViewDetail }

type RecordViewNotFound = {
  $type?: 'tools.ozone.moderation.defs#recordViewNotFound'
  uri: l.AtUriString
}

export type { RecordViewNotFound }

const recordViewNotFound = /*#__PURE__*/ l.typedObject<RecordViewNotFound>(
  $nsid,
  'recordViewNotFound',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { recordViewNotFound }

type SubjectReviewState =
  | 'tools.ozone.moderation.defs#reviewOpen'
  | 'tools.ozone.moderation.defs#reviewEscalated'
  | 'tools.ozone.moderation.defs#reviewClosed'
  | 'tools.ozone.moderation.defs#reviewNone'
  | l.UnknownString

export type { SubjectReviewState }

const subjectReviewState = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.moderation.defs#reviewOpen',
    'tools.ozone.moderation.defs#reviewEscalated',
    'tools.ozone.moderation.defs#reviewClosed',
    'tools.ozone.moderation.defs#reviewNone',
  ]
}>()

export { subjectReviewState }

type ModEventAcknowledge = {
  $type?: 'tools.ozone.moderation.defs#modEventAcknowledge'
  comment?: string

  /**
   * If true, all other reports on content authored by this account will be resolved (acknowledged).
   */
  acknowledgeAccountSubjects?: boolean
}

export type { ModEventAcknowledge }

const modEventAcknowledge = /*#__PURE__*/ l.typedObject<ModEventAcknowledge>(
  $nsid,
  'modEventAcknowledge',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    acknowledgeAccountSubjects: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.boolean(),
    ),
  }),
)

export { modEventAcknowledge }

/** View of a scheduled moderation action */
type ScheduledActionView = {
  $type?: 'tools.ozone.moderation.defs#scheduledActionView'

  /**
   * Auto-incrementing row ID
   */
  id: number

  /**
   * Subject DID for the action
   */
  did: l.DidString

  /**
   * Type of action to be executed
   */
  action: 'takedown' | l.UnknownString

  /**
   * Current status of the scheduled action
   */
  status: 'pending' | 'executed' | 'cancelled' | 'failed' | l.UnknownString

  /**
   * When the scheduled action was created
   */
  createdAt: l.DatetimeString

  /**
   * DID of the user who created this scheduled action
   */
  createdBy: l.DidString

  /**
   * Serialized event object that will be propagated to the event when performed
   */
  eventData?: l.LexMap

  /**
   * Exact time to execute the action
   */
  executeAt?: l.DatetimeString

  /**
   * When the scheduled action was last updated
   */
  updatedAt?: l.DatetimeString

  /**
   * Earliest time to execute the action (for randomized scheduling)
   */
  executeAfter?: l.DatetimeString

  /**
   * Latest time to execute the action (for randomized scheduling)
   */
  executeUntil?: l.DatetimeString

  /**
   * When the action was last attempted to be executed
   */
  lastExecutedAt?: l.DatetimeString

  /**
   * ID of the moderation event created when action was successfully executed
   */
  executionEventId?: number

  /**
   * Reason for the last execution failure
   */
  lastFailureReason?: string

  /**
   * Whether execution time should be randomized within the specified range
   */
  randomizeExecution?: boolean
}

export type { ScheduledActionView }

/** View of a scheduled moderation action */
const scheduledActionView = /*#__PURE__*/ l.typedObject<ScheduledActionView>(
  $nsid,
  'scheduledActionView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    action: /*#__PURE__*/ l.string<{ knownValues: ['takedown'] }>(),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['pending', 'executed', 'cancelled', 'failed']
    }>(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    eventData: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    executeAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeAfter: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executeUntil: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastExecutedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    executionEventId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lastFailureReason: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    randomizeExecution: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { scheduledActionView }

/** Mute incoming reports from an account */
type ModEventMuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventMuteReporter'
  comment?: string

  /**
   * Indicates how long the account should remain muted. Falsy value here means a permanent mute.
   */
  durationInHours?: number
}

export type { ModEventMuteReporter }

/** Mute incoming reports from an account */
const modEventMuteReporter = /*#__PURE__*/ l.typedObject<ModEventMuteReporter>(
  $nsid,
  'modEventMuteReporter',
  /*#__PURE__*/ l.object({
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    durationInHours: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { modEventMuteReporter }

/** Set priority score of the subject. Higher score means higher priority. */
type ModEventPriorityScore = {
  $type?: 'tools.ozone.moderation.defs#modEventPriorityScore'
  score: number
  comment?: string
}

export type { ModEventPriorityScore }

/** Set priority score of the subject. Higher score means higher priority. */
const modEventPriorityScore =
  /*#__PURE__*/ l.typedObject<ModEventPriorityScore>(
    $nsid,
    'modEventPriorityScore',
    /*#__PURE__*/ l.object({
      score: /*#__PURE__*/ l.integer({ maximum: 100, minimum: 0 }),
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventPriorityScore }

/** Resolve appeal on a subject */
type ModEventResolveAppeal = {
  $type?: 'tools.ozone.moderation.defs#modEventResolveAppeal'

  /**
   * Describe resolution.
   */
  comment?: string
}

export type { ModEventResolveAppeal }

/** Resolve appeal on a subject */
const modEventResolveAppeal =
  /*#__PURE__*/ l.typedObject<ModEventResolveAppeal>(
    $nsid,
    'modEventResolveAppeal',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventResolveAppeal }

/** Logs a scheduled takedown action for an account. */
type ScheduleTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#scheduleTakedownEvent'
  comment?: string
  executeAt?: l.DatetimeString
  executeAfter?: l.DatetimeString
  executeUntil?: l.DatetimeString
}

export type { ScheduleTakedownEvent }

/** Logs a scheduled takedown action for an account. */
const scheduleTakedownEvent =
  /*#__PURE__*/ l.typedObject<ScheduleTakedownEvent>(
    $nsid,
    'scheduleTakedownEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      executeAt: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
      executeAfter: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
      executeUntil: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'datetime' }),
      ),
    }),
  )

export { scheduleTakedownEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
type AgeAssurancePurgeEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssurancePurgeEvent'

  /**
   * Comment describing the reason for the purge.
   */
  comment: string
}

export type { AgeAssurancePurgeEvent }

/** Purges all age assurance events for the subject. Only works on DID subjects. Moderator-only. */
const ageAssurancePurgeEvent =
  /*#__PURE__*/ l.typedObject<AgeAssurancePurgeEvent>(
    $nsid,
    'ageAssurancePurgeEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { ageAssurancePurgeEvent }

/** Unmute incoming reports from an account */
type ModEventUnmuteReporter = {
  $type?: 'tools.ozone.moderation.defs#modEventUnmuteReporter'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string
}

export type { ModEventUnmuteReporter }

/** Unmute incoming reports from an account */
const modEventUnmuteReporter =
  /*#__PURE__*/ l.typedObject<ModEventUnmuteReporter>(
    $nsid,
    'modEventUnmuteReporter',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventUnmuteReporter }

/** Moderation event timeline event for a PLC create operation */
const timelineEventPlcCreate = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcCreate',
)

export { timelineEventPlcCreate }

/** Moderation event timeline event for a PLC create operation */
const TimelineEventPlcCreate = /*#__PURE__*/ timelineEventPlcCreate.value

/** Moderation event timeline event for a PLC create operation */
type TimelineEventPlcCreate = typeof TimelineEventPlcCreate

export { TimelineEventPlcCreate }

/** Revert take down action on a subject */
type ModEventReverseTakedown = {
  $type?: 'tools.ozone.moderation.defs#modEventReverseTakedown'

  /**
   * Describe reasoning behind the reversal.
   */
  comment?: string

  /**
   * Names/Keywords of the policy infraction for which takedown is being reversed.
   */
  policies?: string[]

  /**
   * Number of strikes to subtract from the user's strike count. Usually set from the last policy infraction's severity.
   */
  strikeCount?: number

  /**
   * Severity level of the violation. Usually set from the last policy infraction's severity.
   */
  severityLevel?: string
}

export type { ModEventReverseTakedown }

/** Revert take down action on a subject */
const modEventReverseTakedown =
  /*#__PURE__*/ l.typedObject<ModEventReverseTakedown>(
    $nsid,
    'modEventReverseTakedown',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      policies: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 5 }),
      ),
      strikeCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
      severityLevel: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { modEventReverseTakedown }

/** Age assurance status override by moderators. Only works on DID subjects. */
type AgeAssuranceOverrideEvent = {
  $type?: 'tools.ozone.moderation.defs#ageAssuranceOverrideEvent'
  access?: AgeassuranceDefs.Access

  /**
   * The status to be set for the user decided by a moderator, overriding whatever value the user had previously. Use reset to default to original state.
   */
  status: 'assured' | 'reset' | 'blocked' | l.UnknownString

  /**
   * Comment describing the reason for the override.
   */
  comment: string
}

export type { AgeAssuranceOverrideEvent }

/** Age assurance status override by moderators. Only works on DID subjects. */
const ageAssuranceOverrideEvent =
  /*#__PURE__*/ l.typedObject<AgeAssuranceOverrideEvent>(
    $nsid,
    'ageAssuranceOverrideEvent',
    /*#__PURE__*/ l.object({
      access: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.ref<AgeassuranceDefs.Access>(
          (() => AgeassuranceDefs.access) as any,
        ),
      ),
      status: /*#__PURE__*/ l.string<{
        knownValues: ['assured', 'reset', 'blocked']
      }>(),
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { ageAssuranceOverrideEvent }

/** Moderation event timeline event for generic PLC operation */
const timelineEventPlcOperation = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcOperation',
)

export { timelineEventPlcOperation }

/** Moderation event timeline event for generic PLC operation */
const TimelineEventPlcOperation = /*#__PURE__*/ timelineEventPlcOperation.value

/** Moderation event timeline event for generic PLC operation */
type TimelineEventPlcOperation = typeof TimelineEventPlcOperation

export { TimelineEventPlcOperation }

/** Moderation event timeline event for a PLC tombstone operation */
const timelineEventPlcTombstone = /*#__PURE__*/ l.token(
  $nsid,
  'timelineEventPlcTombstone',
)

export { timelineEventPlcTombstone }

/** Moderation event timeline event for a PLC tombstone operation */
const TimelineEventPlcTombstone = /*#__PURE__*/ timelineEventPlcTombstone.value

/** Moderation event timeline event for a PLC tombstone operation */
type TimelineEventPlcTombstone = typeof TimelineEventPlcTombstone

export { TimelineEventPlcTombstone }

/** Logs cancellation of a scheduled takedown action for an account. */
type CancelScheduledTakedownEvent = {
  $type?: 'tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
  comment?: string
}

export type { CancelScheduledTakedownEvent }

/** Logs cancellation of a scheduled takedown action for an account. */
const cancelScheduledTakedownEvent =
  /*#__PURE__*/ l.typedObject<CancelScheduledTakedownEvent>(
    $nsid,
    'cancelScheduledTakedownEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { cancelScheduledTakedownEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
type RevokeAccountCredentialsEvent = {
  $type?: 'tools.ozone.moderation.defs#revokeAccountCredentialsEvent'

  /**
   * Comment describing the reason for the revocation.
   */
  comment: string
}

export type { RevokeAccountCredentialsEvent }

/** Account credentials revocation by moderators. Only works on DID subjects. */
const revokeAccountCredentialsEvent =
  /*#__PURE__*/ l.typedObject<RevokeAccountCredentialsEvent>(
    $nsid,
    'revokeAccountCredentialsEvent',
    /*#__PURE__*/ l.object({
      comment: /*#__PURE__*/ l.string({ minLength: 1 }),
    }),
  )

export { revokeAccountCredentialsEvent }
